import React from "react";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import DataTable from "react-data-table-component";
import toast, {Toaster} from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PreferencesNav from "./PreferencesNav";
import AddIcon from "@mui/icons-material/Add";
import Select from "react-select";

import {
    addTDS,
    editTDS,
    getOrgList,
    getVendorByWare,
    getWarehouseKeyValueDetailsList,
} from "../../services/index";


import { addCell,editCell,getCellByRack,getCellAllRecord } from "../../services/Purchase/CellService";
import { STORE_BASE_URL, WAREHOUSE_URL ,RACK_BASE_URL, CELL_BASE_URL} from "../../CONSTANTS";
import { callPostAxios,callGetAxios } from "../../services/common/common";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import PaginationDataTable from "../Common/PaginationDataTable";

const cellObj = {
    organisationId: "",
    organisationTitle: "",
    recordId: "",
    title: "",
    storeId:"",
    rackId:"",
    wareHouseId: "",
    wareHouseTitle: "",
    storeTitle: "",
    rackTitle : ""
}

const Cell = () => {
    const [tdsInfo, setTdsInfo] = useState({});
    const [wareOptions, setWareOptions] = useState([]);
    const[storeOtions,setStoreOptions] = useState([]);
    const[rackOptions,setRackOptions] = useState([]);
    const [orgOptions, setOrgOptions] = useState([]);
    const [record, setRecord] = useState(cellObj);
    const[salesOptions ,setSalesOptions] = useState([]);
    

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setRecord(cellObj);
        setWareOptions([])
        setShow(false);
    };

    useEffect(() => { 
        getOrganizationList();
    }, []);

    const getOrganizationList = () => {
        getOrgList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    key: d.recordLongId,
                    value: d.recordId,
                    label: d.organisationTitle,
                }));
                setOrgOptions(options);
            } else {
                toast(res);
            }
        });
    }
 
  

    const getSalesRecordsList = (uuid) => {
        callPostAxios(STORE_BASE_URL() + "getStoreByWareHouseUuid/" + uuid , {} ,'StoreOptions').then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setStoreOptions(options);
            } else {
                toast(res.message);
            }
        });
    };
  
    const getRackRecordsList = (uuid) => {
        callPostAxios(RACK_BASE_URL() + "getRackByStore/" + uuid, {}, 'RackOptions')
        .then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setRackOptions(options);
            } else {
                toast.error(res.message);
            }
        })
        .catch((error) => {
            toast.error("Error in RackOptions axios!");
        });
    };
    
    const getWarehouseKeyValueList = (id) => {
        callGetAxios(WAREHOUSE_URL() + "getRecordByOrganisationId/" + id, "WarehouseKeyValueById").then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                }));
                setWareOptions(options);
            } else {
                toast(res);
            }
        });
    };

    const columns = [
        {
            name: "Title",
            cell: (row) => row.title,
        },
        {
            name: "RackTitle",
            cell: (row) => row.rackTitle,
        },
        {
            name : "storeTitle",
            cell: (row) => row.storeTitle,
        },
        {
            name: "Warehouse Title",
            cell: (row) => row.wareHouseTitle,
        },
        {
            name: "Organization Title",
            cell: (row) => row.organisationTitle,
        },
    ];

    const handleClicked = (row) => {
        const _organisationId = orgOptions?.find((item) => item.label === row?.organisationTitle);
        
        setRecord((prev) => ({
            ...prev,
            organisationId: _organisationId,
        })); 
    
        callGetAxios(CELL_BASE_URL() + "getAllCellRecord/" + row.recordId, "WarehouseKeyValueById")
            .then((res) => {
                if (res.errorCode === 0) {
                    const rackOptions = {
                        value: res.responsePacket.rackTitle,
                        label: res.responsePacket.rackTitle,
                    };
    
                    const storeOptions = {
                        value: res.responsePacket.storeTitle,
                        label: res.responsePacket.storeTitle,
                    };
    
                    const warehouseOptions = {
                        value: res.responsePacket.wareHouseTitle,
                        label: res.responsePacket.wareHouseTitle,
                    };
    
                    setRecord({
                        ...record,
                        recordId: row?.recordId,
                        title: row?.title,
                        rackId: rackOptions,
                        storeId: storeOptions,
                        organisationId: _organisationId,
                        wareHouseId: warehouseOptions,
                    });
    
                    setShow(true);
                } else {
                    toast(res.message);
                }
            })
            .catch((error) => {
                console.error("Error in WarehouseKeyValueById axios:", error);
                toast("Error in fetching warehouse data");
            });
    };
    

    const handleData = (e) => {
        setRecord({
            ...record,
            [e.target.name]: e.target.value,
        });
    };

    const handleSave = () => {
        if (!record.organisationId) {
            toast("Please select Organization");
            return;
        }
        if (!record.wareHouseId) {
            toast("Please select Warehouse");
            return;
        }
        if (!record.storeId) {
            toast("Please fill StoreTitle");
            return;
        }
        if(!record.rackId){
            toast("Please fill RackTitle");
            return;
        }
        if (!record.title) {
            toast("Please fill title");
            return;
        }

        const data = {
            organisationId: record.organisationId?.value,
            organisationTitle: record.organisationId?.label,
            wareHouseTitle: record.wareHouseId?.label,
            wareHouseId: record.wareHouseId?.value,
            storeId: record?.storeId?.value,
            rackId : record.rackId?.value,
            title: record?.title,
        };
        if (record.recordId) {
            editCell(record.recordId, data).then((res) => {
                if (res.errorCode == 0) {
                    toast.success(res.message);
                    handleClose();
                } else {
                    toast(res.message);
                    return;
                }
            });
        } else {
            addCell(data).then((res) => {
                if (res.errorCode == 0) {
                    toast.success(res.message);
                    handleClose();
                } else {
                    toast(res.message);
                    return;
                }
            });
        }
    };

    const handleSelect = (e, name) => {
        if ( name === "org"){
            getWarehouseKeyValueList(e.key);
            setRecord((prev) => ({...prev, organisationId: e, wareHouseId: {}, storeId : {}, rackId : {}}));
        } 
        else if(name === "ware"){
            setRecord((prev) => ({...prev, wareHouseId: e,storeId:{}, rackId : {}}))
            getSalesRecordsList(e.value);
        }
        else if(name === "store"){
            setRecord((prev) => ({...prev,storeId:e, rackId : {}}))
            getRackRecordsList(e.value);
          
        }
        else{
           setRecord((pre) => ({...pre, rackId: e}))
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} size="sm">
                <Modal.Header>CELL INFO</Modal.Header>
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Organization:</td>
                            <Select options={orgOptions} value={record.organisationId} onChange={(e) => handleSelect(e, "org")} isDisabled={record.recordId} />
                        </tr>
                        <tr>
                            <td>Warehouse:</td>
                            <Select options={wareOptions} value={record.wareHouseId} onChange={(e) => handleSelect(e, "ware")} isDisabled={record.recordId} />
                        </tr>
                        <tr>
                            <td>Store Title:</td>
                            <Select options={storeOtions} value={record.storeId} onChange={(e) => handleSelect(e,"store")} isDisabled = {record.recordId} name="storeTitle"/>
                        </tr>
                        <tr>
                            <td>Rack Title:</td>
                            <Select options={rackOptions} value={record.rackId} onChange={(e) => handleSelect(e,"rack")} isDisabled = {record.recordId}/>
                        </tr>
                        <tr>
                            <td>Title:</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    className="form-control"
                                    type="text"
                                    name="title"
                                    value={record.title}
                                    onChange={(e) => handleData(e)}
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* <div className="column list-column d-print-none column-small">
                <PreferencesNav />
            </div> */}
            <div className="column content-column">
                <div className="header clearfix" style={{borderBottom: "none"}}>
                    <span className="float-left" style={{fontSize: "35px"}}>
                        Cell/Floor
                    </span>
                </div>

                <div style={{height: 500, width: "100%"}}>
                    <PaginationDataTable
                        columns={columns}
                        paginationUrl={CELL_BASE_URL() + 'getAllRecords'}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        onRowClicked={(data) => {
                            handleClicked(data);
                        }}
                        storeRackCellPallet={true}
                        onNewClicked={()=>setShow(true)}
                        // fixedHeader
                        // subHeader
                        // subHeaderComponent={
                        //     <>
                        //         <button
                        //             id="ember5839"
                        //             className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                        //             type="button"
                        //             onClick={() => setShow(true)}
                        //         >
                        //             <AddIcon />
                        //             New
                        //         </button>
                        //     </>
                        // }
                    />
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default Cell;